
import '../css/collaborate.css';
import { useState } from 'react';
import emailjs from 'emailjs-com';

const handleEmail = async (email, checkBox) => {
    if (email === null || email === "" || !email.includes("@")) {
        alert("Please Enter a Valid Email");
        return;
    }
    else if (!checkBox) {
        alert("Please Accept The Terms and Argreement before procedding");
        return;
    }
    let templateParams = {
        from_name: "talkoftech.collab@gmail.com",
        to_name: email,
        subject: "TalkOfTech Collaboration",
        my_html: `Hello, it’s Sagnik,admin of TalkOfTech. Check this link out <a href="https://developerstalkoftech.netlify.app/">Join us</a>`
    }

    emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_USER_ID
    )

}
function Collaborate() {

    const [email, setEmail] = useState('');
    const [checkBox, setCheckBox] = useState(false);
    return <>

        <div className="background-image-container">
            <div className="text-container-collaborate">
                <h3 className="small-text">You want to join us.</h3>
                <h1 className="large-text">That's Awesome</h1>
                <div className="email-container-collab">
                    <input className="email-box-collab" required type="email" placeholder="Enter Your Email" onChange={text => setEmail(text.target.value)}></input>
                    <button className="email-button-collab" onClick={() => handleEmail(email, checkBox)}>Let's Go</button>
                </div>
                <div className="checkbox-container">
                    <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" onClick={() => setCheckBox(true)}></input>
                    <label className="checkbox-text">I Have Read All The Rules and Wish To Proceed.</label>
                    <a href="#terms-and-conditions" className="link-terms">
                        Terms and Conditions
                </a>
                </div>

            </div>
            <div className="terms-and-aggrement-container" id="terms-and-conditions">
                <div className="policy-text">
                    <h1 className="heading-terms-and-conditions">Terms and Conditions</h1>
                    <div className="div-terms-block">

                        <div className="div-term-1"><h3>
                            Content
                            </h3>
                            <div className="article-terms">
                                Any article not related to tech will be deleted by admin and the user will be warned. repeating the
                                offence will result in banning of the account
                            </div>

                        </div>
                        <div className="div-term-1"><h3>
                            Money
                            </h3>
                            <div className="article-terms">
                                No money is involved in this case. you will not be given any money for any of your article . This
                                website is for Knowledge and no business is involved . The revenue generated by the ads are completely
                                used for purchasing server storage and other equipments on demand
                            </div>
                        </div>
                        <div className="div-term-1">
                            <h3>
                                Promotions
                            </h3>
                            <div className="article-terms">
                                Promotions of this website is always welcome.if You want to promote the site in any way then please contact
                                admin through the links. Using of data without permission is strictly prohibited.
                            </div>
                        </div>

                    </div>
                    <div className="footer">
                        Policy of This website may be updated later and all the Users will be informed.  You will have complete freedom to
                        deny the policy and resign from the website. Suggestions on updated policy or new future policies are always welcome
                    </div>
                </div>
            </div>
        </div>



    </>
}
export default Collaborate;
